import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";

export async function verifyAdditionalEmail(emailVerificationCode) {
    const endpoint = `${configuration.apiServer}${configuration.apiVerifyEmailPath}/${emailVerificationCode}`;
    return EffectUtility.postToModel(BaseModel, endpoint);
}
